import React, { FC } from 'react';
import { NavLink, useNavigate } from "react-router-dom";
import logo from '../../assets/logo.png';
import { useSessionStore } from '../../stores/sessionStore';
import { useTranslation } from 'react-i18next';

interface LeftDrawerProps {
    isSidebarVisible: boolean;
}

const LeftDrawer: FC<LeftDrawerProps> = ({ isSidebarVisible }) => {
    const sessionStore = useSessionStore();
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <>
            {/* isSidebarVisible prop'una göre show sınıfını ekliyoruz */}
            <section className={`section d-none d-lg-block section-sidebar ${isSidebarVisible ? "show" : "hide"}`}>
                <div className="logo">
                    <a href="/" title="Be Partners Logo">
                        <img src={logo} className="img-fluid" alt="logo" />
                    </a>
                </div>
                
                <div className="offcanvas-body">
                    <div className="sidebar">
                        <nav className="navbar navbar-expand">
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav">
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/"><i
                                            className="bi bi-bar-chart"></i> {t('dashboard')}</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/users"><i
                                            className="bi bi-people"></i> {t('members')}</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/applications"><i
                                            className="bi bi-chat-left-dots"></i> {t('applications')}</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/approved-apps"><i className="bi bi-journal-check"></i> {t('approvedApplications')}</NavLink>
                                    </li>
                                    <div className="menu-divider">{t('settings')}</div>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/settings"><i
                                            className="bi bi-sliders"></i> {t('settings')}</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/logs"><i
                                            className="bi bi-journal-text"></i> {t('logs')}</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href='javascript()' onClick={() => {
                                            sessionStore.logout();
                                            navigate('/login')
                                        }}>
                                            <i className="bi bi-power"></i> {t('signout')}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </section>

            {/* Mobil versiyon */}
            <section className="section section-sidebar mobile-section-sidebar offcanvas offcanvas-start" data-bs-scroll="true"
                     data-bs-backdrop="true" tabIndex={-1} id="sideBarMobile" aria-labelledby="sideBarMobileLabel">

    <div className="logo">
                    <a href="/" title="Be Partners Logo">
                        <img src={logo} className="img-fluid" alt="logo" />
                    </a>
                </div>


                <div className="offcanvas-body">
                    <div className="sidebar">
                        <nav className="navbar navbar-expand">
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav">
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/"><i
                                            className="bi bi-bar-chart"></i> {t('dashboard')}</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/users"><i
                                            className="bi bi-people"></i> {t('members')}</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/applications"><i
                                            className="bi bi-chat-left-dots"></i> {t('applications')}</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/approved-apps"><i className="bi bi-journal-check"></i> {t('approvedApplications')}</NavLink>
                                    </li>
                                    <div className="menu-divider">{t('settings')}</div>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/settings"><i
                                            className="bi bi-sliders"></i> {t('settings')}</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/logs"><i
                                            className="bi bi-journal-text"></i> {t('logs')}</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href='javascript()' onClick={() => {
                                            sessionStore.logout();
                                            navigate('/login')
                                        }}>
                                            <i className="bi bi-power"></i> {t('signout')}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>

            </section>
        </>
    );
};

export default LeftDrawer;
